import PaperGrain from './components/layout/PaperGrain';
import Header from './components/sections/Header';
import About from './components/sections/About';
import Experience from './components/sections/Experience';
import Skills from './components/sections/Skills';
import Projects from './components/sections/Projects';

const App = () => (
  <div className="min-h-screen bg-paper-warm font-serif text-ink">
    <PaperGrain />
    <main className="relative mx-auto my-10 max-w-3xl border-[3px] border-ink bg-paper-base shadow-sleeve">
      <Header />
      <About />
      <Experience />
      <Skills />
      <Projects />
    </main>
  </div>
);

export default App;
